import {createAsyncThunk} from "@reduxjs/toolkit";

import {
    getBlockList as getBlockListApi,
    addBlockList as addBlockListApi,
    updateBlockList as updateBlockListApi,
    deleteBlockList as deleteBlockListApi,
    getBlockById as getBlockByIdApi
} from "../../helpers/helper";

import {toast} from "react-toastify";

export const getBlockList = createAsyncThunk("Block/getBlockList", async (data: any) => {
    try {
        const {searchData, pagination} = data;
        const response = await getBlockListApi(searchData, pagination);
        return response;
    } catch (error) {
        return error;
    }
});
export const addBlockList = createAsyncThunk("Block/addBlockList", async (block: any) => {
    try {
        const response = addBlockListApi(block);
        const data = await response;
        toast.success("Block Added Successfully", {autoClose: 2000});
        return data;
    } catch (error) {
        toast.error("Block Added Failed", {autoClose: 2000});
        return error;
    }
});

export const updateBlockList = createAsyncThunk("Block/update", async (dataArr: any) => {
    try {
        const {formData, id} = dataArr;
        const response = updateBlockListApi(formData, id);
        const data = await response;
        toast.success("Block Updated Successfully", {autoClose: 2000});
        return data;
    } catch (error) {
        toast.error("Block Updated Failed", {autoClose: 2000});
        return error;
    }
});
export const deleteBlockList = createAsyncThunk("Block/deleteBlockList", async (categoryId: any) => {
    try {
        const response = deleteBlockListApi(categoryId);
        console.log(response);
        toast.success("Block Deleted Successfully", {autoClose: 2000});
        return categoryId;
    } catch (error) {
        toast.error("Block Deleted Failed", {autoClose: 2000});
        return error;
    }
})
export const getBlockById = createAsyncThunk("block/getBlockById", async (id: any) => {
    try {
        const response = getBlockByIdApi(id);
        return response;
    } catch (error) {
        return error;
    }
});
